import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/pro-solid-svg-icons";
import { Standard } from "./api/useListStandards";

interface Props {
  suggestions: Standard[];
  onAdd: (standard: Standard) => void;
  onPreview: (standard: Standard) => void;
}

const SuggestedServices = ({ suggestions, onAdd, onPreview }: Props) => {
  if (!suggestions.length) return null;

  return (
    <div className="suggestedServices">
      <div className="suggestedServicesHeader">Suggested Services</div>
      <div className="suggestedServicesHint">
        Services that are typically added with your selections.
      </div>
      <ul>
        {suggestions.map((standard) => (
          <li key={standard.id}>
            <button
              type="button"
              className="suggestedServiceName"
              onClick={() => onAdd(standard)}
              title="Add to selected services"
            >
              {standard.name}
            </button>
            {standard.category && (
              <span className="suggestedServiceCategory">
                {standard.category}
              </span>
            )}
            <div className="previewService review">
              <FontAwesomeIcon
                icon={faEye}
                aria-label={`Preview ${standard.name}`}
                onClick={() => onPreview(standard)}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SuggestedServices;
